import * as React from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import { connect } from "react-redux";
import { GlobalState } from "../../store";
import * as actions from "../../store/cases/actions";
import { Case, User, Category, Tag } from "../../api/classes";
import CaseListItem from "../../pages/cases/caseListItem";
import {
  List,
  TextField,
  IconButton,
  Typography,
  Chip,
  MenuItem,
} from "@material-ui/core";
import AddIcon from "@material-ui/icons/Add";
import CategorySelect from "../categorySelect";
import FolderSelect from "../folderSelect";
import * as constants from "../../api/constants";
import FilterView from "../filter";
import { DubitoSvc } from "src/api";

interface Props {
  open: boolean;
  value: string;
  description: string;
  onClose: () => void;
  onChange: (reason: string, description: string) => void;
}
const reasons = [
  "Yeterli delil yok",
  "Deliller güvenilir değil",
  "Deliller açık ve ulaşılabilir değil",
  "İddia doğru",
  "Editöryal karar",
];
class NoAnalysisReasonDialog extends React.Component<Props> {
  state = {
    open: this.props.open,
    scroll: "paper",
    reason: this.props.value,
    detailText: this.props.description || "",
    creating: false,
  };
  componentWillReceiveProps(next: Props) {
    // if (!this.props.open && next.open) {
    this.setState({ open: next.open });
    // }
  }

  handleCreate = () => {
    this.setState({ open: false, creating: false });
    this.props.onChange(this.state.reason, this.state.detailText);
  };
  handleClose = () => {
    if (this.state.creating) {
      return;
    }
    this.setState({ open: false, query: "" });
    this.props.onClose();
  };

  render() {
    return (
      <div>
        <Dialog
          open={this.state.open}
          onClose={this.handleClose}
          scroll={"paper"}
          aria-labelledby="scroll-dialog-title"
          maxWidth="sm"
          fullWidth
        >
          <DialogTitle id="scroll-dialog-title">
            <div style={{ display: "flex", alignItems: "center" }}>
              <span style={{ flex: 1 }}>No Analysis Reason</span>
            </div>
          </DialogTitle>
          <DialogContent>
            <div
              style={{
                borderRadius: 8,
                borderWidth: 2,
                borderStyle: "solid",
                padding: 8,
                borderColor: "orange",
              }}
            >
              <Typography>
                ⚠️ This information will be public on{" "}
                <a target="_blank" href="https://teyit.org/editormasasi">
                  teyit.org/editormasasi
                </a>
              </Typography>
              <TextField
                placeholder="What is the reason?"
                autoFocus
                value={this.state.reason}
                onChange={(e) => this.setState({ reason: e.target.value })}
                style={{ width: "100%", marginTop: 12 }}
                fullWidth
                select
                helperText="What is the reason?"
              >
                {reasons.map((i) => (
                  <MenuItem value={i}>{i}</MenuItem>
                ))}
              </TextField>
            </div>
            <div
              style={{
                marginTop: 24,
                borderRadius: 8,
                borderWidth: 2,
                borderStyle: "solid",
                padding: 8,
                borderColor: "green",
              }}
            >
              <Typography>
                Internal use only detailed description, will not be public.
              </Typography>
              <TextField
                placeholder="Please give detail about the process."
                autoFocus
                value={this.state.detailText}
                onChange={(e) => this.setState({ detailText: e.target.value })}
                style={{ width: "100%" }}
                fullWidth
                multiline
                rows={6}
                error={this.errorValidDescription}
                helperText="This field should be at least 80 characters long"
              />
            </div>
          </DialogContent>
          <DialogActions>
            <Button
              disabled={this.state.creating}
              onClick={this.handleClose}
              color="primary"
            >
              Cancel
            </Button>
            <Button
              disabled={this.errorValidDescription}
              onClick={this.handleCreate}
              color="primary"
            >
              Ok
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
  get errorValidDescription() {
    return !this.state.detailText || this.state.detailText.length < 80;
  }
}
export default connect(
  (state: GlobalState, own: Props) => ({}),
  (dispatch) => ({})
)(NoAnalysisReasonDialog);



// WEBPACK FOOTER //
// ./src/components/dialogs/noAnalysisReasonDialog.tsx